import { observer } from 'mobx-react-lite';
import React from 'react';
import { useMediaQuery } from 'usehooks-ts';

import { CardAgeEntity } from '@/entities';
import { Description, ModalContent, Typography } from '@/shared/ui';
import { AdditionalInfo } from '@/shared/ui/desktop/additional-info';
import {
  AdditionalInfoMobile,
  AdditionalInfoMobileDefaultIcon,
} from '@/shared/ui/mobile/additional-info';
import { useStore } from '@/store/context';

import styles from './select-account-age.module.scss';

export const SelectAccountAgeFeature = observer(() => {
  const withdrawal = useStore()?.withdrawal;
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <ModalContent
      className={styles['container']}
      topRightSlot={
        <ModalContent.CloseButton
          onClick={() => withdrawal?.closeCreateTrade()}
        />
      }>
      {isDesktop ? (
        <Typography className={styles['title']}>
          Specify the age of the Roblox account
        </Typography>
      ) : (
        <ModalContent.Title
          className={styles['title-mobile']}
          title={' Specify the age of the Roblox account'}
        />
      )}

      <ModalContent.Body>
        <CardAgeEntity
          onClick={() => withdrawal?.setSelectedAccountAge('under')}
          variant={'danger'}
          title={'Age is under 13'}
          subtitle={'Access through friendship'}
        />
        <CardAgeEntity
          onClick={() => withdrawal?.setSelectedAccountAge('above')}
          variant={'success'}
          title={'Age is over 13'}
          subtitle={'Access via link'}
        />
      </ModalContent.Body>
      <ModalContent.Footer>
        {isDesktop ? (
          <AdditionalInfo
            align={'center'}
            width={'full-w'}
            variant={'info'}
            icon={
              <AdditionalInfo.DefaultIcon
                variant={'info'}
                name={'info-square'}
              />
            }>
            For ages 13+, access is available via the link
          </AdditionalInfo>
        ) : (
          <AdditionalInfoMobile
            width={'full-w'}
            variant={'info'}
            icon={
              <AdditionalInfoMobileDefaultIcon
                variant={'info'}
                name={'info-square'}
              />
            }>
            For ages 13+, access is available via the link
          </AdditionalInfoMobile>
        )}
        <Description
          message={
            'For accounts under the age of 13, item trading is only possible through friendship'
          }
        />
      </ModalContent.Footer>
    </ModalContent>
  );
});
